
export class MenuNotificaciones{
    public label:string;//Nombre del campo del formulario
    public items:any = []

    constructor(){
        this.label = '0 notificaciones pendientes';
        this.items = [];
    }
} 